import { Injectable, NgModule } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ngx-toastr';
class NotificationsService {
    setNotificationStrategy(notificationStrategy) {
        this._notificationStrategy = notificationStrategy;
    }
    success(message, options = {}) {
        this._notificationStrategy.success(message, options);
    }
    error(message, title, options = {}) {
        this._notificationStrategy.error(message, title, options);
    }
    warning(message, options = {}) {
        this._notificationStrategy.warning(message, options);
    }
    info(message, options = {}) {
        this._notificationStrategy.info(message, options);
    }
}
NotificationsService.ɵfac = function NotificationsService_Factory(t) { return new (t || NotificationsService)(); };
NotificationsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NotificationsService, factory: NotificationsService.ɵfac });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationsService, [{
        type: Injectable
    }], null, null); })();

class NotificationStrategy {
}

class PortalNotificationStrategy extends NotificationStrategy {
    /**
     *
     */
    constructor(toastrService) {
        super();
        this.toastrService = toastrService;
    }
    success(message, options) {
        if (!options.onHidden) {
            this.toastrService.success(message, null, options);
        }
        else {
            this.toastrService.success(message, null, options).onHidden.subscribe(() => options.onHidden());
        }
    }
    error(message, title, options) {
        this.toastrService.error(message, title, options);
    }
    warning(message, options) {
        this.toastrService.warning(message, null, options);
    }
    info(message, options) {
        this.toastrService.info(message, null, options);
    }
    show(message, title, options, type) {
        throw new Error('Method not implemented.');
    }
}

class PortalNotificationsService extends NotificationsService {
    constructor(toastrService) {
        super();
        this.toastrService = toastrService;
        super.setNotificationStrategy(new PortalNotificationStrategy(this.toastrService));
    }
}
PortalNotificationsService.ɵfac = function PortalNotificationsService_Factory(t) { return new (t || PortalNotificationsService)(ɵngcc0.ɵɵinject(ɵngcc1.ToastrService)); };
PortalNotificationsService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: PortalNotificationsService, factory: PortalNotificationsService.ɵfac });
PortalNotificationsService.ctorParameters = () => [
    { type: ToastrService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(PortalNotificationsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.ToastrService }]; }, null); })();

class NotificationsModule {
}
NotificationsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NotificationsModule });
NotificationsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NotificationsModule_Factory(t) { return new (t || NotificationsModule)(); }, providers: [{ provide: NotificationsService, useClass: PortalNotificationsService }] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationsModule, [{
        type: NgModule,
        args: [{
                providers: [{ provide: NotificationsService, useClass: PortalNotificationsService }]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { NotificationStrategy, NotificationsModule, NotificationsService, PortalNotificationsService };

//# sourceMappingURL=mt-ng2-notifications-module.js.map